(function () {
  var scheduled = false;
  var lastWidth = 0;

  function align() {
    scheduled = false;
    var grids = document.querySelectorAll('.product-grid.product-grid--has-push');
    grids.forEach(function (grid) {
      var editorialPushes = grid.querySelectorAll('.grid__item--push-editorial');
      var productPushes = grid.querySelectorAll('.grid__item--push:not(.grid__item--push-cover):not(.grid__item--push-editorial)');
      if (!editorialPushes.length && !productPushes.length) return;

      var sampleCard = grid.querySelector('.grid__item:not(.grid__item--push)');
      if (!sampleCard) return;
      var sampleImage = sampleCard.querySelector('.card__inner.ratio')
        || sampleCard.querySelector('.card__inner')
        || sampleCard.querySelector('.card__media');
      if (!sampleImage) return;

      var imageH = sampleImage.getBoundingClientRect().height;
      var cardH = sampleCard.getBoundingClientRect().height;
      var infoH = Math.max(0, cardH - imageH);
      var rowGapStr = getComputedStyle(grid).rowGap || getComputedStyle(grid).gridRowGap || '0';
      var rowGap = parseFloat(rowGapStr) || 0;

      var isMobile = window.innerWidth < 990;

      // Distance from top of row 1 image to bottom of row N image
      function imageBandHeight(push) {
        var spanRows = parseInt(getComputedStyle(push).getPropertyValue('--push-span-rows'), 10) || 2;
        return spanRows * imageH + (spanRows - 1) * (infoH + rowGap);
      }

      // Editorial push (card-push wraps media): LI height = image band height
      editorialPushes.forEach(function (push) {
        if (isMobile) { push.style.height = ''; return; }
        var target = imageBandHeight(push);
        if (target > 0) push.style.height = target + 'px';
      });

      // Product push (card-product): constrain card__inner to image band height so
      // the LI naturally becomes (image band + info) without overshooting the row area.
      productPushes.forEach(function (push) {
        var inner = push.querySelector('.card__inner');
        if (!inner) return;
        if (isMobile) {
          inner.style.height = '';
          inner.style.setProperty('--push-ratio-override', '');
          return;
        }
        var target = imageBandHeight(push);
        if (target > 0) {
          inner.style.height = target + 'px';
        }
      });
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(align);
  }

  function onResize() {
    var w = window.innerWidth;
    if (w === lastWidth) return;
    lastWidth = w;
    schedule();
  }

  function initialAlign() {
    lastWidth = window.innerWidth;
    schedule();
    setTimeout(schedule, 600);
  }

  if (document.readyState === 'complete') {
    initialAlign();
  } else {
    window.addEventListener('load', initialAlign);
  }
  window.addEventListener('resize', onResize);
  document.addEventListener('shopify:section:load', schedule);

  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n.nodeType === 1 && (
          (n.matches && n.matches('.product-grid--has-push')) ||
          (n.querySelector && n.querySelector('.product-grid--has-push'))
        )) {
          schedule();
          return;
        }
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
